import type { ReactNode } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface FilterBarSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  dataTour?: string;
}

export interface FilterBarProps {
  search?: FilterBarSearchProps;
  /** Selects u otros controles de filtro, renderizados a continuación del buscador. */
  children?: ReactNode;
  className?: string;
}

/** FilterBar canónico del Design System (F5) — barra de búsqueda + filtros de una lista/tabla. */
export function FilterBar({ search, children, className }: FilterBarProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      {search ? (
        <div className="relative min-w-[220px] flex-1 sm:max-w-xs">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden />
          <Input
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder ?? "Buscar…"}
            data-tour={search.dataTour}
            className="pl-9"
          />
        </div>
      ) : null}
      {children}
    </div>
  );
}
